export const TOOTH_STATUSES = {
  healthy: {
    stroke: "#4CAF50",
    fill: "none",
    label: "Sano",
  },
  caries: {
    stroke: "#F44336",
    fill: "#FFEBEE",
    label: "Caries",
  },
  filled: {
    stroke: "#FF9800",
    fill: "#FFF3E0",
    label: "Obturado",
  },
  extracted: {
    stroke: "#757575",
    fill: "#F5F5F5",
    label: "Extraído",
  },
  prosthesis: {
    stroke: "#2196F3",
    fill: "#E3F2FD",
    label: "Prótesis",
  },
  crown: {
    stroke: "#9C27B0",
    fill: "#F3E5F5",
    label: "Corona",
  },
  implant: {
    stroke: "#607D8B",
    fill: "#ECEFF1",
    label: "Implante",
  },
};

export const CHART_TYPES = {
  adult: "Adulto",
  child: "Niño",
  mixed: "Mixto",
};

export const FDI_NOTATION = {
  // Cuadrantes de dientes permanentes
  UPPER_RIGHT: [11, 12, 13, 14, 15, 16, 17, 18],
  UPPER_LEFT: [21, 22, 23, 24, 25, 26, 27, 28],
  LOWER_LEFT: [31, 32, 33, 34, 35, 36, 37, 38],
  LOWER_RIGHT: [41, 42, 43, 44, 45, 46, 47, 48],

  // Cuadrantes de dientes deciduos
  UPPER_RIGHT_DECIDUOUS: [51, 52, 53, 54, 55],
  UPPER_LEFT_DECIDUOUS: [61, 62, 63, 64, 65],
  LOWER_LEFT_DECIDUOUS: [71, 72, 73, 74, 75],
  LOWER_RIGHT_DECIDUOUS: [81, 82, 83, 84, 85],
};

export const formatTeethData = (teethArray) => {
  return teethArray.reduce((acc, tooth) => {
    if (tooth.tooth_number && tooth.status) {
      acc[tooth.tooth_number] = tooth.status;
    }
    return acc;
  }, {});
};

export const parseTeethDataToArray = (teethData) => {
  return Object.entries(teethData || {}).map(([tooth_number, status]) => ({
    tooth_number,
    status,
  }));
};

// Función para determinar el tipo de diente según la notación FDI
export const getToothType = (toothNumber) => {
  const num = parseInt(toothNumber);

  if (num >= 11 && num <= 48) {
    return "permanent";
  } else if (num >= 51 && num <= 85) {
    return "deciduous";
  }

  return "unknown";
};

// Función para obtener el nombre del cuadrante
export const getQuadrantName = (toothNumber) => {
  const num = parseInt(toothNumber);

  if (num >= 11 && num <= 18) return "Upper Right";
  if (num >= 21 && num <= 28) return "Upper Left";
  if (num >= 31 && num <= 38) return "Lower Left";
  if (num >= 41 && num <= 48) return "Lower Right";
  if (num >= 51 && num <= 55) return "Upper Right Deciduous";
  if (num >= 61 && num <= 65) return "Upper Left Deciduous";
  if (num >= 71 && num <= 75) return "Lower Left Deciduous";
  if (num >= 81 && num <= 85) return "Lower Right Deciduous";

  return "Unknown";
};

// Validar datos del odontograma antes de enviar al backend
export const validateDentalChartData = (chartData) => {
  const errors = [];

  if (!chartData.patient_id) {
    errors.push("ID del paciente es requerido");
  }

  if (!chartData.provider_id) {
    errors.push("ID del provider es requerido");
  }

  if (
    !chartData.chart_type ||
    !Object.keys(CHART_TYPES).includes(chartData.chart_type)
  ) {
    errors.push("Tipo de odontograma inválido");
  }

  return {
    isValid: errors.length === 0,
    errors,
  };
};
